export { downloadCsvFile } from "../../../utils/download";

export const filterInquiries = (inquiries, searchTerm) => {
  const query = searchTerm.toLowerCase();

  return inquiries.filter((inquiry) => {
    return (
      inquiry.company_name?.toLowerCase().includes(query) ||
      inquiry.contact_name?.toLowerCase().includes(query) ||
      inquiry.email?.toLowerCase().includes(query) ||
      inquiry.sector?.toLowerCase().includes(query) ||
      inquiry.naics_category?.toLowerCase().includes(query)
    );
  });
};
